import type { JSX } from "react";
import type { ValueOrI18nKeyProp } from "../../../util/type";
import type { IconComponent } from "../../atoms/icons/icon-component";
import { Typography, css, styled } from "@mui/material";
import { useServices } from "../../../services/services-context";


const PanelTitleRoot = styled(Typography)(({ theme }) => css`
	display: flex;
	align-items: center;
	
	margin-inline-start: ${theme.spacing(1)};
	user-select: none;

	.panelTitle__icon {
		margin-inline-end: ${theme.spacing(1)};
	}
	.panelTitle__content {
		margin: ${theme.spacing(1, 0)};
	}
`) as typeof Typography;

export type PanelTitleProps = ValueOrI18nKeyProp<"title", string> & {
	titleId?: string;
	headingLevel?: 2 | 3;
	icon?: IconComponent;
};
export const PanelTitle = ({ titleId, headingLevel = 2, title, titleKey, titleValues, icon: Icon }: PanelTitleProps): JSX.Element => {
	const { translation } = useServices();

	return (
		<PanelTitleRoot
			id={ titleId }
			className="panel__title"
			variant="h3"
			component={ headingLevel === 2 ? "h2" : "h3" }
		>
			{ Icon && <Icon className="panelTitle__icon" sx={{ marginInlineEnd: 1 }}/> }
			<span className="panelTitle__content">
				{ translation.resolveValueOrI18nKey(title, titleKey, titleValues) }
			</span>
		</PanelTitleRoot>
	);
};